const ROUTES = {
  "/": {
    "name": "HomePage1b73e945C29848f99cf62e12cc0d8e61",
    "type": "HTML",
    "key": "home-page"
  },
  "/_admin/*": {
    "name": "AdminPages761775b054d641bf93044773a20b6bb7",
    "type": "HTML",
    "key": "admin-pages"
  },
  "/about": {
    "name": "AboutUsPage74e798882a33405d9c7a52636e1e4e48",
    "type": "HTML",
    "key": "about-us-page"
  },
  "/about/leveling": {
    "name": "AboutLevelingPage8b19b3d6071d4d4bA2e3Cd7e0536b5b3",
    "type": "HTML",
    "key": "about-leveling-page"
  },
  "/about/offerings": {
    "name": "AboutOfferings18dceb9fFf944f4dAd5934c42f458a84",
    "type": "HTML",
    "key": "about-offerings"
  },
  "/about/susan": {
    "name": "AboutSusan4c0dc4444d5e405183dbF6a0ad996433",
    "type": "HTML",
    "key": "about-susan"
  },
  "/events/public": {
    "name": "PublicEventsPageFd53b17298d24c969dc3C331f3015048",
    "type": "HTML",
    "key": "public-events-page"
  },
  "/join": {
    "name": "JoinUsPageA5dcb418035e4a5f92c145632725e805",
    "type": "REFERENCE",
    "key": "join-us-page"
  },
  "/members-old/*": {
    "name": "MemberPagesOld9d3344159a764415A2d583babbf3fcca",
    "type": "HTML",
    "key": "member-pages-old"
  },
  "/members/messages/*": {
    "name": "MessagePages6d0e7dde5b894012B3172d2b8e701f72",
    "type": "HTML",
    "key": "message-pages"
  },
  "/resources": {
    "name": "ResourcesPage835a7006Fedf4a3c96f60c8578d33dd5",
    "type": "REFERENCE",
    "key": "resources-page"
  },
  "/signup/*": {
    "name": "SignupPagesA69374e40dfa4a189b5e1d326a09e345",
    "type": "REFERENCE",
    "key": "signup-pages"
  }
};

export default ROUTES;